<template>
    <vs-prompt
        title="订单拆单"
        class="break-up-order"
        :active="visible"
        @close="handleCancel"
        buttonsHidden
    >
        <div>
            <div class="title">请在需拆分成新订单的商品中输入拆分数量</div>
            <div v-for="(tabitem, fridx) in tableDataAll" :key="fridx">
                <div class="label">订单号:{{ tabitem.orderNo }}</div>
                <div>
                    <div class="label">订单1:</div>
                    <el-table
                        :data="tabitem.skulist[0].skulist"
                        class="marTop18"
                        :span-method="columnSpanMethod"
                        height="220">
                        <template v-for="item in finalTableHeader">
                            <template v-if="item.code === 'input'">
                                <el-table-column
                                    :fixed="item.fixed ? item.fixed : false"
                                    :label="item.name"
                                    :width="item.width"
                                    :key="item.code"
                                >
                                    <template slot-scope="scope">
                                        <vs-input
                                            @mousewheel.prevent
                                            class="w-full"
                                            v-model="scope.row.input"
                                            @input="handleInput(scope.row, scope.$index, true, tabitem)"
                                        />
                                    </template>
                                </el-table-column>
                            </template>
                            <!-- 商品名称 -->
                            <template v-else-if="item.code === 'skuInfo'">
                                <el-table-column :key="item.code"
                                                 :fixed="item.fixed ? item.fixed : false"
                                                 :label="item.name"
                                                 :width="item.width">
                                    <template slot-scope="scope">
                                        <div>{{ scope.row.skuName }}</div>
                                        <div class="item-tip">{{ scope.row.barCode }}</div>
                                    </template>
                                </el-table-column>
                            </template>
                            <template v-else-if="item.code === 'sendSkuInfo'">
                                <el-table-column :key="item.code"
                                                 :fixed="item.fixed ? item.fixed : false"
                                                 :label="item.name"
                                                 :width="item.width">
                                    <template slot-scope="scope">
                                        <div>{{ scope.row.sendSkuName }}</div>
                                        <div class="item-tip">{{ scope.row.sendSkuBarCode }}</div>
                                    </template>
                                </el-table-column>
                            </template>
                            <template v-else>
                                <el-table-column v-if="item.isStock"
                                                 :key="item.code"
                                                 :label="item.name"
                                                 :width="item.width">
                                    <template slot="header">
                                        <div class="stock-header">{{ item.name }}</div>
                                        <div>库存</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <div :style='getStockStyle(scope.row, scope.$index, item.code, true, fridx)'>
                                            {{ scope.row[item.code] }}
                                        </div>
                                        <!-- <div :style="scope.row[item.code + 'Class'] ? 'color:#46c93a;': 'color:#ff4757;'">{{scope.row[item.code]}}</div> -->
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    v-else
                                    :label="item.name"
                                    :prop="item.code"
                                    :width="item.width"
                                    :fixed="item.fixed ? item.fixed : false"
                                    :key="item.code">
                                </el-table-column>
                            </template>
                        </template>
                    </el-table>
                </div>
                <div>
                    <div class="label">订单2</div>
                    <el-table
                        :data="tabitem.skulist[1].skulist"
                        class="marTop18"
                        :span-method="columnSpanMethod"
                        height="220">
                        <template v-for="item in finalTableHeader">
                            <template v-if="item.code === 'input'">
                                <el-table-column
                                    :fixed="item.fixed ? item.fixed : false"
                                    :label="item.name"
                                    :width="item.width"
                                    :key="item.code"
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.residueInput }}
                                    </template>
                                </el-table-column>
                            </template>
                            <!-- 商品名称 -->
                            <template v-else-if="item.code === 'skuInfo'">
                                <el-table-column :key="item.code"
                                                 :label="item.name"
                                                 :width="item.width"
                                                 :fixed="item.fixed ? item.fixed : false">
                                    <template slot-scope="scope">
                                        <div>{{ scope.row.skuName }}</div>
                                        <div class="item-tip">{{ scope.row.barCode }}</div>
                                    </template>
                                </el-table-column>
                            </template>
                            <template v-else-if="item.code === 'sendSkuInfo'">
                                <el-table-column :key="item.code"
                                                 :label="item.name"
                                                 :width="item.width"
                                                 :fixed="item.fixed ? item.fixed : false">
                                    <template slot-scope="scope">
                                        <div>{{ scope.row.sendSkuName }}</div>
                                        <div class="item-tip">{{ scope.row.sendSkuBarCode }}</div>
                                    </template>
                                </el-table-column>
                            </template>
                            <template v-else>
                                <el-table-column v-if="item.isStock"
                                                 :key="item.code"
                                                 :fixed="item.fixed ? item.fixed : false"
                                                 :label="item.name"
                                                 :width="item.width">
                                    <template slot="header">
                                        <div class="stock-header">{{ item.name }}</div>
                                        <div>库存</div>
                                    </template>
                                    <template slot-scope="scope">
                                        <div :style='getStockStyle(scope.row, scope.$index, item.code, false, fridx)'>
                                            {{ scope.row[item.code] }}
                                        </div>
                                        <!-- <div :style="scope.row[item.code+'Class'] ? 'color:#46c93a;': 'color:#ff4757;'">{{scope.row[item.code]}}</div> -->
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    v-else
                                    :label="item.name"
                                    :prop="item.code"
                                    :width="item.width"
                                    :fixed="item.fixed ? item.fixed : false"
                                    :key="item.code">
                                </el-table-column>
                            </template>
                        </template>
                    </el-table>
                </div>
            </div>

            <div class="footer">
                <vs-button
                    color="primary"
                    size="small"
                    type="filled"
                    @click="handleClick"
                >立即拆单
                </vs-button
                >
            </div>
        </div>
    </vs-prompt>
</template>

<script>
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import {OrderApi} from "@/modules/server-api/commodity-sys/order";
import store from '../store.js';

export default {
    components: {
        GcCmpVsTable,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        orderNo: {
            type: String,
            default: "",
        },
        tableData: {
            type: Array,
            default: () => [],
        },
        allStockList: {
            type: Array,
            default: () => []
        }
    },
    mixins: [store],
    data() {
        return {
            loading: false,
            allSendSku:{},
            tableHeader: [
                {
                    name: "下单商品",
                    width: "210px",
                    code: "skuInfo",
                    fixed: "left"
                },
                {
                    name: "初始单号",
                    width: "180px",
                    code: "originOrderNo",
                    fixed: "left"
                },
                {
                    name: "下单数量",
                    width: "80px",
                    code: "orderNum",
                    fixed: "left"
                },
                {
                    name: "拆分数量 ",
                    width: "100px",
                    code: "input",
                    fixed: "left"
                },
                {
                    name: "发货商品",
                    width: "210px",
                    code: "sendSkuInfo",
                },
                {
                    name: "发货数量",
                    width: "100px",
                    code: "sendSpecNum",
                },
                {
                    name: "总库存",
                    width: "100px",
                    code: "allStockNum",
                }
            ],
        };
    },
    computed: {
        tableData2() {
            let tableData2 = JSON.parse(JSON.stringify(this.tableData));
            // console.log( "tableData2", tableData2 )
            let that = this;
            tableData2 = tableData2.map(child => {
                let splits = {};
                child.skulist.filter((item) => {

                    item.allNum = item.allNum ||0;
                    item.residueInput = item.residueInput ||0;
                    item.sendSpecNum = item.residueInput + item.unit;
                    if (!isNaN(item.input) && item.split) {
                        if ( splits[item.barCode]){
                            splits[item.barCode].push(item);
                        }else {
                            splits[item.barCode] = [item];
                        }
                    }else {
                        that.updateSplitSku( child , [item], false );
                    }

                    if ( item.allNum > 0 ){
                        return item;
                    }
                });
                console.log( '拆分', splits )
                Object.keys(splits).forEach((key) => {
                    that.updateSplitSku(child, splits[key], false);
                })
                return child;
            })
            return tableData2;
        },
        tableDataAll() {
            let tableDataAll = [];
            let tableConcat = [];
            this.tableData.slice().map(child => {
                // console.log(child);
                child.skulist.map((item,index) => {
                    console.log(item);
                    // item.allNum = item.allNum||0;
                    // console.log(item.input);
                    if (!isNaN(item.input)) {
                        item.sendSpecNum = item.input + item.unit;
                    }else {
                        this.updateSplitSku(child, [item], true);
                    }
                });
                tableConcat.push(child);
            });
            tableConcat = tableConcat.concat(this.tableData2);
            tableConcat.map(mapItem => {
                if (tableDataAll.length === 0) {
                    tableDataAll.push({orderNo: mapItem.orderNo, skulist: [mapItem]})
                } else {
                    let res = tableDataAll.some(item => {//判断相同订单号，有就添加到当前项
                        if (item.orderNo === mapItem.orderNo) {
                            item.skulist.push(mapItem)
                            return true
                        }
                    })
                    if (!res) {//如果没找相同日期添加一个新对象
                        tableDataAll.push({orderNo: mapItem.orderNo, skulist: [mapItem]})
                    }
                    // if (!res) {//如果没找相同日期添加一个新对象
                    // }
                }
            });
            console.log( "tableDataAll", tableDataAll )
            return tableDataAll;
        },
        finalTableHeader() {
            let extraHead = [];
            // console.log(this.allStockList)
            this.allStockList.map(item => {
                let obj = {};
                obj.code = item.id;
                obj.name = item.title;
                obj.isStock = true;
                obj.width = '130px';
                extraHead.push(obj);
            });
            // console.log(this.tableHeader.concat(extraHead))
            return this.tableHeader.concat(extraHead);
        },
    },
    methods: {
        updateSplitSku(skuList, sItems, sIndex){
            let finalSendInfo = this.computeSplitSendNum(sItems, sIndex);
            // console.log(finalSendInfo);
            // console.log(skuList.skulist);
            // console.log( "tableData3  index",finalSendInfo, skuList, sItems, sIndex )
            skuList.skulist.filter((item, index) => {
                //变更后的发货数量：[箱, 盒]
                sItems.map( sItem =>{
                    if (item.split && sItem.barCode === item.barCode) {//两种规格
                        let boxUnit = this.orderUnitList[0];
                        if (item.unit === boxUnit) {
                            item.residueInput = finalSendInfo[0].num;
                            item.allNum = finalSendInfo[0].allNum;
                            item.sendSpecNum = finalSendInfo[0].specNum;
                            item.sendNum = finalSendInfo[0].num;
                        } else {//盒
                            item.residueInput = finalSendInfo[1].num;
                            item.allNum = finalSendInfo[1].allNum;
                            item.sendSpecNum = finalSendInfo[1].specNum;
                            item.sendNum = finalSendInfo[1].num;
                        }
                    } else if ( sItem.barCode === item.barCode){
                        item.residueInput = finalSendInfo[1].num;
                        item.allNum = finalSendInfo[1].allNum;
                        item.sendSpecNum = finalSendInfo[1].specNum;
                        item.sendNum = finalSendInfo[1].num;
                    }
                })
            });
        },
        updateSku(skuList, sItem, sIndex){
            let finalSendInfo = this.computeSendNum(sItem, sIndex);
            // console.log( "tableData2  index", skuList, sItem, sIndex )
            skuList.skulist.filter((item, index) => {
                //变更后的发货数量：[箱, 盒]
                if (item.split && sItem.barCode === item.barCode) {//两种规格
                    let boxUnit = this.orderUnitList[0];
                    if (item.unit === boxUnit) {
                        item.residueInput = finalSendInfo[0].num;
                        item.sendSpecNum = finalSendInfo[0].specNum;
                        item.sendNum = finalSendInfo[0].num;
                    } else {//盒
                        item.residueInput = finalSendInfo[1].num;
                        item.sendSpecNum = finalSendInfo[1].specNum;
                        item.sendNum = finalSendInfo[1].num;
                    }
                } else if (  sItem.barCode === item.barCode){
                    item.residueInput = finalSendInfo[1].num;
                    item.sendSpecNum = finalSendInfo[1].specNum;
                    item.sendNum = finalSendInfo[1].num;
                }
            });
        },
        handleCancel() {
            // this.tableDataAll = []
            this.$emit("update:visible", false);
        },

        handleInput(data, index, sTable, item) {
            //去除上下箭头需校验
            // console.log('handleInput', data, index, sTable, item);
            let attrName = 'input';
            if (!data[attrName] || data[attrName] === '') {
                data[attrName] = 0;
                return false;
            }
            let num = data[attrName];
            console.log('handleInput num', num);
            if (!/^[0-9]+.?[0-9]*/.test(num)) {
                this.$notifyError("请输入数字");
                data[attrName] = undefined;
                return false;
            }
            // else if (num > data.num) {
            //     this.$notifyInfo("超过最大拆分数量");
            //     data[attrName] = data.num;
            // }

            //修改为箱规 盒规分别计算num
            if(data.unit === this.orderUnitList[0]){
              num = parseInt(data.input) * parseInt(data.boxSpec);
              if(num > data.num){
                this.$notifyInfo("超过最大拆分数量");
                let boxNum=parseInt(data.allNum/data.boxSpec)
                data[attrName] = boxNum;
              }
            }else if(data.unit === this.orderUnitList[1]){
              num = parseInt(data.input)
              if(num > data.num){
                this.$notifyInfo("超过最大拆分数量");
                data[attrName] = data.num;
              }
            }


            if ( !data.split ){
                let num = parseInt(data.input);
                console.log(num);
                // console.log(this.orderUnitList,"===========")
                if ( data.unit === this.orderUnitList[0] ){
                    num = parseInt(data.input) *  parseInt(data.boxSpec);
                }
                item.skulist[0].skulist.filter( c =>{
                    if ( data.barCode === c.barCode && data.unit !== c.unit ){

                        if ( c.unit === this.orderUnitList[0] ){
                            num += parseInt(c.input) * parseInt(c.boxSpec);
                        }else {
                            num += parseInt(c.input) ;
                        }
                    }
                });

                if ( num > data.num ){
                    this.$notifyInfo("超过最大拆分数量");
                    data[attrName] = undefined;
                }
            }
        },
        //动态计算发货数量:
        computeSplitSendNum(data, sTable) {
            // console.log(data);
            //更新发货数量
            let boxUnit = this.orderUnitList[0];
            let finalBoxSendSku = {};
            let finalUnitSendSku = {};

            let unitNum = 0;
            let boxNum = 0;
            // console.log( "computeSplitSendNum", data, unitNum, boxNum );
            data.map( item => {
                let input = item.input||0;
                if ( item.unit === boxUnit){
                    boxNum = parseInt(input) ;
                }else {
                    unitNum = parseInt(input) ;
                }
            })
            const boxSpec = data[0].boxSpec;
            const allNum = data[0].num;
            const unit = data[0].unit;

            if (boxSpec ) {
                let num = allNum - unitNum - (boxNum * boxSpec);
                //箱
                let numBox = Math.floor(num / boxSpec) ;
                finalBoxSendSku.num = numBox;
                finalBoxSendSku.allNum = num;
                finalBoxSendSku.specNum = numBox + boxUnit;
                //盒
                let numUnit = num - (numBox * boxSpec);
                finalUnitSendSku.num = numUnit;
                finalUnitSendSku.allNum = num;
                // debugger;
                finalUnitSendSku.specNum = numUnit + this.orderUnitList[1];

                // console.log( "动态计算发货数量", boxSpec,finalBoxSendSku,finalUnitSendSku )
            }else {
                finalUnitSendSku.num = allNum - unitNum;
                finalUnitSendSku.allNum = allNum - unitNum;
                finalUnitSendSku.specNum = allNum - unitNum + this.orderUnitList[1];
                // console.log( "动态计算发货数量 盒", allNum,unitNum,finalUnitSendSku )
            }
            console.log([finalBoxSendSku, finalUnitSendSku])
            return [finalBoxSendSku, finalUnitSendSku];
        },
        //动态计算发货数量:
        computeSendNum(data, sTable) {
            //更新发货数量
            let currInput = data.input;
            const boxSpec = parseInt(data.boxSpec);//箱规
            let finalBoxSendSku = {};
            let finalUnitSendSku = {};
            if (boxSpec && !sTable) {
                let boxUnit = this.orderUnitList[0];
                let num = 0;
                //判断是箱
                if (data.unit === boxUnit) {
                    num = data.num - currInput * boxSpec;
                    if (num < 0) {
                        this.$notifyInfo("超过最大拆分数量");
                    }
                } else {
                    num = data.num - currInput;
                    if (num < 0) {
                        this.$notifyInfo("超过最大拆分数量");
                    }
                }
                //箱
                let numBox = Math.floor(num / boxSpec);
                finalBoxSendSku.num = numBox;
                finalBoxSendSku.specNum = numBox + boxUnit;
                //盒
                let numUnit = num - (numBox * boxSpec);
                finalUnitSendSku.num = numUnit;
                finalUnitSendSku.specNum = numUnit + this.orderUnitList[1];

                console.log( "动态计算发货数量", boxSpec,finalBoxSendSku,finalUnitSendSku )
            }else if (sTable) {
                let num = isNaN( currInput ) ? 0 : currInput;
                if ( data.unit === this.orderUnitList[1]){
                    finalUnitSendSku.num = data.num - num;
                    finalUnitSendSku.specNum = data.num - num + this.orderUnitList[1];
                }
            }else {
                finalUnitSendSku.num = data.num - currInput;
                finalUnitSendSku.specNum = data.num - currInput + this.orderUnitList[1];
            }
            return [finalBoxSendSku, finalUnitSendSku];
        },
        handleClick() {
            // console.log(this.tableDataAll)
            let splitFlag = false;
            let params = [];
            let skulistone = [], skuall = [];
            this.tableDataAll.map(item => {
                skulistone.push(item.skulist[0].skulist);
                //获取接口参数
                let obj = {}, arr = [];
                obj.detail = [];
                obj.orderNo = item.skulist[0].orderNo;
                item.skulist[0].skulist.map(child => {
                    //只取合并单元格的第一条数据和只有一条数据的
                    let num = child.input && !isNaN( child.input ) ? parseInt(child.input):0;
                    if (item.orderNo === item.skulist[0].orderNo) {
                        if (child.split < 2) {
                            obj.detail.push({
                                originOrderNo: child.originOrderNo,
                                skuCode: child.skuCode,
                                amount:  num,
                                orderType: child.orderType,
                            });
                        }else{
                           let boxNum = num * child.boxSpec;
                            obj.detail.map(a=>{
                                if ( a.skuCode === child.skuCode){
                                    a.amount = parseInt(a.amount) + boxNum;
                                }
                            })
                        }

                    }
                })

                params.push( obj );

            })

            //拆分订单list
            skulistone.map(item => {
                //把当前拆分的订单放到skuall，如果没有则为[];
                let skuarr = item.filter(child => child.input)
                skuall.push(skuarr);
            })

            //判断skuall当前的子元素是否为空数组，如果为空数组，则表示当前拆分订单为空，拆分数量为0
            let isbreakupFlag = skuall.filter(item => item.length == 0);
            if (isbreakupFlag.length) {
                this.$notifyError("请先配置拆分数量");
                return;
            }

            this.tableDataAll.map(item => {
                if (item.skulist[1].skulist.length == 0) {
                    splitFlag = true;
                }
            })

            if (splitFlag) {
                this.$notifyError("未拆分出新订单，请检查拆分数量配置");
                return;
            }
            console.log( params )
            OrderApi.splitOrder(params).then(res => {
                if (res.succ === 1) {
                    this.$emit("success")
                    this.$emit("update:visible", false);
                } else {
                    this.$notifyError(res.error);
                }
            })
        },
        //计算库存是否充足
        getStockStyle(row, index, currStockId, sTable, fridx) {
            let isFit = false;
            const cSendNum = Number(row.sendNum);
            let stockNum = row[currStockId];
            if (stockNum.indexOf('/') != -1) {
                const availableAmount = row[currStockId].split('/')[0];
                if (row.split) {// 合并
                    if (row.split == 2) {
                        const firstRow = sTable ? this.tableData[fridx].skulist[index - 1] : this.tableData2[fridx].skulist[index - 1];
                        const firstRowSendNum = firstRow.sendNum;
                        const firstRowAvaAmount = firstRow[currStockId].split('/')[0];
                        if (Number(availableAmount) >= Number(cSendNum) && Number(firstRowAvaAmount) >= Number(firstRowSendNum)) {
                            isFit = true;
                        }
                    }
                    //当row.split != 2时 执行
                    else{
                      if (Number(availableAmount) >= Number(cSendNum)) {
                        isFit = true;
                      }
                    }
                } else {
                    if (Number(availableAmount) >= Number(cSendNum)) {
                        isFit = true;
                    }
                }
            }
            if (isFit) {
                return 'color:#46c93a;';
            } else {
                return 'color:#ff4757';
            }
        }
    },
    created(){
        console.log(111)
    },
    mounted () {
        console.log(this.tableData)
    }
    // mounted() {},
};
</script>

<style lang="scss" scoped>
.break-up-order {
    .title {
        font-size: 12px;
    }

    .label {
        margin-top: 20px;
        font-size: 12px;
        font-weight: 600;
    }

    .span-line {
        display: flex;

        & /deep/ .el-popover__reference-wrapper {
            margin-left: 2px;
        }
    }

    & /deep/ .vs-dialog {
        min-width: 80%;
        height: 700px;
        min-height: 500px;

        .vs-dialog-text {
            height: 92%;
            padding-bottom: 0;
            overflow-y: scroll;
        }
    }

    & /deep/ .vs-input--input {
        padding: 2px 4px !important;
    }

    /deep/ .vs-dialog .vs-table--content {
        height: 200px !important;
    }

    .footer {
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: right;
    }

    /deep/ .el-table td, /deep/ .el-table th {
        padding: 0;
        font-size: 12px;
    }

    /deep/ .el-table th {
        color: #626262;
        font-weight: bold;
    }

    .item-tip {
        font-size: 12px;
        color: #aaa;
    }

    .stock-header {
        text-align: left;
    }
}

.popover-container {
    max-height: 500px;
    overflow: auto;

    & /deep/ .vs-con-table .vs-con-tbody .vs-table--tbody-table {
        font-size: 12px;
        padding: 0;
    }
}

</style>
